import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import { useAddBasicBoardModal } from '../context/AddBasicBoardModalContext';
import { isDisabledSaveButton } from '../utils/isDisabledSaveButton';

const AddBasicBoardModalFooter: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddBasicBoardModal();

  const isSaveButtonDisabled = isDisabledSaveButton({
    ...data,
  });

  return (
    <Modal.Footer className="bg-light">
      <button
        className="btn btn-primary"
        type="button"
        disabled={isSaveButtonDisabled}
        onClick={actions.handleSaveBasicBoard}
      >
        {data.actionType === actionTypes.ADD
          ? t('CreateBoard')
          : t('UpdateBoard')}
      </button>
    </Modal.Footer>
  );
};

export default AddBasicBoardModalFooter;
